import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

class LoadFormCreate {
  constructor() {
    this.cache = new Map();
    this.pendingRequests = new Map();
  }

  clearCache() {
    this.cache.clear();
  }

  async callLoadFormCreate(payload) {
    const key = JSON.stringify(payload);

    if (this.cache.has(key)) {
      return this.cache.get(key);
    }

    if (this.pendingRequests.has(key)) {
      // await data response
      try {
        const response = await this.pendingRequests.get(key);
        this.cache.set(key, response);
        this.pendingRequests.delete(key);
        return response;
      } catch (error) {
        console.log(error.response.data.error);
        this.pendingRequests.delete(key);
        throw error;
      }
    }

    this.pendingRequests.set(key, this.fetchData(payload));

    try {
      const response = await this.pendingRequests.get(key);
      this.cache.set(key, response);
      this.pendingRequests.delete(key);
      return response;
    } catch (error) {
      console.log(error.response.data.error);
      this.pendingRequests.delete(key);
      throw error;
    }
  }

  async fetchData(payload) {
    const isTokenValid = await checkTokenExpiration();
    return axios.post(BASE_URL_API + "object/load-form-create", payload, {
      headers: {
        Authorization: isTokenValid,
      },
    });
  }
}

const loadFormCreateService = new LoadFormCreate();

export default loadFormCreateService;
